export const SIDER_WIDTH = 237;
